export enum TaskStatus {
  InProgress = 'in-progress',
  Done = 'done',
}

export enum TaskType {
  Default = 'default',
  Daily = 'daily',
}

export enum TaskSubtaskType {
  PulseProfileCreation = 'pulse-profile-creation',
  PulseReaction = 'pulse-reaction',
  PulsePostCreation = 'pulse-post-creation',
  PulsePostCommentCreation = 'pulse-post-comment-creation',
  PulseProfileSubscription = 'pulse-profile-subscription',
  InvestAccountCreation = 'invest-account-creation',
  InvestboxCreation = 'investbox-creation',
  InvestAcademyLessonPassed = 'invest-academy-lesson-passed',
  FriendInvitation = 'friend-invitation',
  FriendProductInvitation = 'friend-product-invitation',
  InvestmentPurchase = 'investment-purchase',
  InvestboxTopUp = 'investbox-top-up',
  RiskProfileTesting = 'risk-profile-testing',
  TMsgChannelSubscription = 't-msg-channel-subscription',
  InvestmentGift = 'investment-gift',
  InvestEnableAutoTrackingStrategy = 'invest-enable-auto-tracking-strategy',
  CollectPortfolio = 'collect-portfolio',
  ClickLink = 'click-link',
}

export enum TaskExecutionRules {
  NoPulseProfile = 'no-pulse-profile',
  OverEighteen = 'over-eighteen',
  HasInvestBox = 'has-invest-box',
  HasBrokerAccount = 'has-broker-account',
  HasBlackCard = 'has-black-card',
  HasPulseProfile = 'has-pulse-profile',
  InvestRiskProfileIsDefined = 'invest-risk-profile-is-defined',
  InvestRiskProfileIsNotDefined = 'invest-risk-profile-is-not-defined',
}

export enum TaskForUITypes {
  Done = 'done',
  Active = 'active',
  Blocked = 'blocked',
}

export const TASK_NEW_STATUS_UPDATE_DELAY_MS = 5000;
